<template>
  <v-row>
    <v-col cols="12">
      <Header />
    </v-col>
    <v-col cols="12">
      <Products v-if="id == 'products'" />
    </v-col>
  </v-row>
</template>

<script>
import Header from '@/components/promo/Header';
import Products from '@/components/promo/Products';
export default {
  name: 'PromoDetail',
  components: {
    Header,
    Products
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {}
};
</script>
